import React from 'react';
import { motion } from 'framer-motion';
import { FileSearchIcon, NetworkIcon, ShieldCheckIcon, BarChart3Icon, UsersIcon, ClockIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { SectionEyebrow } from './ui/SectionEyebrow';
const capabilities = [{
  icon: FileSearchIcon,
  title: 'Structured RFI Intake',
  description: 'Standardize incoming requests with dynamic forms that ensure you get the right information the first time.'
}, {
  icon: NetworkIcon,
  title: 'Workflow Routing',
  description: 'Automatically route requests to the appropriate analyst or unit based on workload, clearance, and specialty.'
}, {
  icon: BarChart3Icon,
  title: 'Performance Dashboards',
  description: 'Track SLAs, monitor unit performance, and identify bottlenecks with real-time operational metrics.'
}, {
  icon: ShieldCheckIcon,
  title: 'Immutable Audit Trail',
  description: 'Every action, view, and edit is logged to ensure complete accountability and compliance readiness.'
}, {
  icon: UsersIcon,
  title: 'Secure Collaboration',
  description: 'Role-based access control ensures analysts can collaborate securely without exposing sensitive data.'
}, {
  icon: ClockIcon,
  title: 'Custom Taxonomies',
  description: "Adapt the platform to your agency's specific terminology, classifications, and operational procedures."
}];
export function CapabilitiesGrid() {
  return <section id="platform" className="py-24 bg-iris-surface relative" data-id="element-28">
      <div className="absolute inset-0 bg-topo-pattern opacity-50 pointer-events-none" data-id="element-29"></div>

      <Container className="relative z-10" data-id="element-30">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-31">
          <SectionEyebrow text="Platform Capabilities" className="justify-center mb-4" data-id="element-32" />
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-6" data-id="element-33">
            EVERYTHING YOU NEED. NOTHING YOU DON'T.
          </h2>
          <p className="text-iris-muted text-lg" data-id="element-34">
            A purpose-built toolkit designed specifically for the rigorous
            demands of intelligence and investigative workflows.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-35">
          {capabilities.map((cap, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} className="bg-iris-black border border-iris-border p-8 group hover:border-iris-green transition-colors relative overflow-hidden" data-id="element-36">
              {/* Hover accent line */}
              <div className="absolute top-0 left-0 w-full h-1 bg-iris-green transform -translate-y-full group-hover:translate-y-0 transition-transform" data-id="element-37"></div>

              <cap.icon className="w-8 h-8 text-iris-green mb-6" data-id="element-38" />
              <h3 className="text-xl font-display font-bold text-white mb-3 tracking-wide" data-id="element-39">
                {cap.title}
              </h3>
              <p className="text-iris-muted text-sm leading-relaxed" data-id="element-40">
                {cap.description}
              </p>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}